

























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { Store, StoreModel } from '@/models/admin/store';
import { Template, TemplateField } from '@/models/template';
import { Base } from '@/components/common/base';
import { storeService, templateService } from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class SaveStoreTemplatePage extends Base {
  public storeViewModel: any = {};
  public storeModel: StoreModel = {};
  public templateModel: Template = {
    id: '',
    key: '',
    name: '',
    text: '',
  };
  public form: any = {};
  public storeTemplateFields: Array<VFields<any>> = [];
  public storeId: number = 0;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public templateFields: TemplateField[] = [];
  public templates: Template[] = [];
  public requestProgress: boolean = false;

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'Template' },
        })
        .catch(() => {
          // catch block
        });
    } else if (methodName === 'backToStoreAdd') {
      this.$router
        .push({
          name: 'admin.stores.add',
          params: {
            tenantId: this.tenantId.toString(),
            enterpriseId: this.enterpriseId.toString(),
            tab: 'Template',
          },
        })
        .catch(() => {
          // catch block
        });
    } else if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, this.$t('stores.templates.alertInvalidForm'));
        this.resetMethodName(methodName);
        return;
      }
      this.saveStoreTemplate();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    } else {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreAdd',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    this.setTemplateFields();
    this.tenantId = Number(this.$route.params.tenantId);
    this.enterpriseId = Number(this.$route.params.enterpriseId);
    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
      this.getStoreInfo();
    }
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.getTemplateFields();
  }
  public setTemplateFields(): void {
    this.storeTemplateFields = [
      {
        key: 'key',
        required: true,
        type: 'v-alynk-select',
        templateOptions: {
          disabled: this.$route.params.templateId ? true : false,
          label: this.$t(
            'stores.templates.templateFields.selectTemplate'
          ) as string,
          text: 'name',
          value: 'name',
          required: true,
          items: this.templates,
          altag: 'Select Templates',
          loading: false,
          events: {
            onChange: (templates: Template[], value: any) => {
              const template = templates.find((m) => m.name === value);
              if (template) {
                this.templateModel.key = template.name;
                this.templateModel.text = template.text;
              }
            },
          },
          rules: [
            v => this.required('Select Template', v)
          ]
        },
      },
      {
        key: 'text',
        required: false,
        type: 'v-alynk-textarea',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.templates.templateFields.text') as string,
          loading: false,
        },
      },
    ];
  }

  public validateStoreTemplate(): Vue & { validate: () => boolean } {
    return this.$refs.storeTemplateForm as Vue & { validate: () => boolean };
  }

  public async saveStoreTemplate(): Promise<void> {
    if (this.validateStoreTemplate().validate()) {
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        if (this.templateModel.id === '') {
          await storeService.saveTemplate(
            this.storeViewModel.id,
            this.templateModel
          );
          const existing = this.storeModel.overrideTemplateJson.find((m) => {
            return m.key === this.templateModel.key;
          });
          if (existing) {
            existing.text = this.templateModel.text;
          } else {
            this.storeModel.overrideTemplateJson.push(this.templateModel);
          }
          this.storeViewModel.overrideTemplateJson = this.storeModel.overrideTemplateJson;
          this.showAlert(true, 'Template added successfully');
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                tenantId: this.tenantId.toString(),
                enterpriseId: this.enterpriseId.toString(),
                storeId: this.storeId.toString(),
                tab: 'Template'
              },
            })
            .catch(() => {
              // catch block
            });
        } else {
          await storeService.updateTemplate(
            this.storeViewModel.id,
            this.templateModel
          );
          const existing = this.storeModel.overrideTemplateJson.find((m) => {
            return m.key === this.templateModel.key;
          });
          if (existing) {
            existing.text = this.templateModel.text;
          } else {
            this.storeModel.overrideTemplateJson.push(this.templateModel);
          }
          this.storeViewModel.overrideTemplateJson = this.storeModel.overrideTemplateJson;
          this.showAlert(true, this.$t('stores.templates.alertUpdateTemplate'));
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                tenantId: this.tenantId.toString(),
                enterpriseId: this.enterpriseId.toString(),
                storeId: this.storeId.toString(),
                tab: 'Template'
              },
            })
            .catch(() => {
              // catch block
            });
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }
  public async getStoreInfo(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.storeTemplateFields);
      const response = await storeService.getStore(this.storeId);
      this.storeViewModel = response;
      this.storeModel.id = this.storeViewModel.id;
      this.storeModel.overrideTemplateJson =
        this.storeViewModel.overrideTemplateJson || [];
      await this.getAllTemplates();
      this.setTemplateFields();
    } finally {
      this.formlyHideSkeleton(this.storeTemplateFields);
    }
  }
  public setTemplate() {
    if (this.$route.params.templateId) {
      const selectedTemplate = this.storeViewModel.overrideTemplateJson.find(
        (m) => m.key === this.$route.params.templateId
      ) || {
        key: '',
        name: '',
        text: '',
      };

      this.templateModel = selectedTemplate;
    }
  }
  public async getTemplateFields(): Promise<void> {
    const response = await templateService.getTemplateFields();
    this.templateFields = response.results;
  }
  public appendField(field: string): void {
    this.templateModel.text += `{${field}}`;
  }
  public async getAllTemplates(): Promise<void> {
    const response = await templateService.getAllTemplates();
    response.results.forEach((m) => {
      const existingTemplate = this.storeModel.overrideTemplateJson.find(
        (temp) => {
          return temp.key === m.name;
        }
      );
      this.templates.push(m);
    });
    this.setTemplate();
  }
}
